<template>
  <div v-show="enableFiltersWrap" class="d-print-none">
    <v-card elevation="0" tile class="pt-2">
      <v-container class="py-0 px-1">
        <v-form ref="form">
          <div>
            <div v-show="enableRange">
              <div class="d-flex overline justify-start align-center px-3">
                <v-icon class="grey--text" x-small>mdi-calendar</v-icon>
                <div class="pl-2 grey--text" style="font-size: 10px">
                  {{ $t("interval") }}
                </div>
                <v-divider class="ml-4"></v-divider>
                <div class="pl-2 grey--text" style="font-size: 10px">
                  <Gmt />
                </div>
              </div>
              <Range />
            </div>

            <div
              v-if="showFiltersLine"
              class="d-flex overline justify-start align-center px-3"
            >
              <!-- <v-divider class="mr-4"></v-divider> -->
              <v-icon class="grey--text" x-small>mdi-filter</v-icon>
              <div class="pl-2 grey--text" style="font-size: 10px">
                {{ $t("filters") }}
              </div>
              <v-divider class="ml-4"></v-divider>
            </div>

            <!-- Wrap -->
            <div
              class="d-flex filters-wraps"
              :class="
                $vuetify.breakpoint.smAndDown ? 'flex-column' : 'flex-row'
              "
            >
              <!-- Autocomplete Players -->
              <div
                class="flex-grow-1 px-2 pb-3"
                v-show="enableAutocompleteNamePlayers"
              >
                <AutocompleteNamePlayers />
              </div>

              <!-- Select Result Bet -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableSelectResultBet">
                <SelectResultBet />
              </div>

              <!-- Select Status Bet Online -->
              <div
                class="flex-grow-1 pb-3 px-2"
                v-show="enableSelectStatusBetOnline"
              >
                <SelectStatusBetOnline />
              </div>

              <!-- Select Status Bet Online -->
              <div
                class="flex-grow-0 pb-0 px-2"
                v-show="enableCasinoBetsStatus"
              >
                <CasinoBetsStatus />
              </div>

              <div
                class="flex-grow-1 px-2 d-flex align-center"
                v-if="enableCasinoRange"
              >
                <CasinoRange />
              </div>

              <!-- Select number of events in bet -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableEventNumber">
                <EventNumber />
              </div>

              <!-- Select gaming type (casino or sport) -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableGamingType">
                <GamingType />
              </div>

              <div class="flex-grow-1 px-2 pb-3" v-show="enablePaymentMonth">
                <PaymentMonth />
              </div>

              <!-- SEMPRE EM ULTIMO -->
              <!-- Group Export -->
              <div class="flex-grow-1 px-2 pb-3" v-show="enableGroupExport">
                <GroupExport />
              </div>
            </div>
            <!-- / Wrap Bets -->

            <!-- <v-divider class="mx-2"></v-divider> -->
            <v-card-actions class="pb-3">
              <v-divider class="mr-4"></v-divider>
              <!-- <v-spacer></v-spacer> -->
              <v-btn
                v-if="!clearButtonHide"
                class="mr-1 white black--text"
                @click="reset()"
                :disabled="disabledSave"
              >
                {{ $t("toClean") }}
              </v-btn>
              <v-btn class="info" @click="save()" :disabled="disabledSave">
                <v-icon v-if="handleFilterButtonTxt" small left>mdi-download</v-icon>
                <v-icon v-else small left>mdi-filter</v-icon>
                {{ handleFilterButtonTxt ? $t("download") : $t("toFilter") }}
              </v-btn>
            </v-card-actions>
          </div>
        </v-form>
      </v-container>
    </v-card>
    <v-divider></v-divider>
  </div>
</template>
<script>
import Gmt from "@/components/gmt/";
import { mapState } from "vuex";
import Range from "./Range";
import AutocompleteNamePlayers from "./AutocompleteNamePlayers";
import SelectResultBet from "./SelectResultBet";
import SelectStatusBetOnline from "./SelectStatusBetOnline";
import GroupExport from "./GroupExport";
import EventNumber from "./EventNumber";
import GamingType from "./GamingType";
import PaymentMonth from "./PaymentMonth";
import CasinoRange from "./CasinoRange";
import CasinoBetsStatus from "./CasinoBetsStatus";

export default {
  name: "components-common-filter",
  components: {
    Gmt,
    Range,
    AutocompleteNamePlayers,
    SelectResultBet,
    SelectStatusBetOnline,
    GroupExport,
    EventNumber,
    GamingType,
    PaymentMonth,
    CasinoRange,
    CasinoBetsStatus,
  },
  data: () => ({
    showFiltersLine: true,
  }),
  computed: mapState({
    exportDocStatus() {
      return this.$store.state.filters.groupExport.value;
    },

    handleFilterButtonTxt() {
      const names = [
        "AgentUsersReport",
        "AgentSportsReport",
        "AgentDepositsReport"
      ];

      let routeName;

      names.forEach((name) => {
        if (this.$route.name.includes(name)) {
          return routeName = name;
        }
      });

      return this.$route.name === routeName && this.exportDocStatus != "";
    },
    clearButtonHide() {
      const paths = [
        "/reports/users",
        "/reports/sports",
        "/reports/deposits",
      ];

      let hide = false;

      paths.forEach((path) => {
        if (this.$route.path.includes(path)) {
          hide = true;
        }
      });

      return hide;      
    },
    enableFiltersWrap() {
      return this.$store.state.filters.enableWrap;
    },
    enableRange() {
      return this.$store.state.rangeGlobal.enable;
    },
    enableAutocompleteNamePlayers() {
      return this.$store.state.filters.autocompleteNamePlayers.enable;
    },
    enableSelectResultBet() {
      return this.$store.state.filters.selectResultBet.enable;
    },
    enableSelectStatusBetOnline() {
      return this.$store.state.filters.selectStatusBetOnline.enable;
    },
    enableEventNumber() {
      return this.$store.state.filters.eventNumber.enable;
    },
    enableGamingType() {
      return this.hasCasino && this.$store.state.filters.gamingType.enable;
    },
    enableGroupExport() {
      return this.$store.state.filters.groupExport.enable;
    },
    enablePaymentMonth() {
      return this.$store.state.filters.paymentMonth.enable;
    },
    disabledSave() {
      return this.$store.state.filters.disabledSave;
    },
    loggedStatus() {
      return this.$store.state.logged.status;
    },
    hasCasino() {
      return (
        this.$store.state.operators && this.$store.state.operators.casino != "0"
      );
    },
    enableCasinoRange() {
      return this.$store.state.filters.casinoRange.enable;
    },
    enableCasinoBetsStatus() {
      return this.$store.state.filters.casinoBetsStatus.enable;
    },
  }),
  mounted() {
    this.enableFilters(this.$route);

    if (this.$route.name === "AgentFinancialCommissions") {
      this.showFiltersLine = this.hasCasino;
    }
  },
  watch: {
    $route: function(route) {
      this.enableFilters(route);

      if (!route.meta.filters) return;
      else if (
        route.meta.filters.length == 1 &&
        route.meta.filters[0] == "RangeGlobal"
      ) {
        this.showFiltersLine = false;
      } else {
        this.showFiltersLine = true;
      }

      if (route.name === "AgentFinancialCommissions") {
        this.showFiltersLine = this.hasCasino;
      }
    },
    //Reset all filters values when the user logout
    loggedStatus(val) {
      if (!val) {
        this.reset();
      }
    },
  },
  methods: {
    /// Set Save in store vuew;
    save() {
      this.$store.commit("setSave", true);
      this.$store.commit("DisabledSave", true);
    },

    /// Reset Filters to Default;
    reset() {
      // Components Reset
      this.$store.commit("setPlayerName", "");
      this.$store.commit("setSelectResultBet", "");
      this.$store.commit("setSelectStatusBetOnline", "");
      this.$store.commit("setEventNumber", "");
      this.$store.commit("setSave", false);
      this.$store.commit("DisabledSave", false);
      this.$store.commit("setGroupExport", "");
      this.$store.commit("setCasinoRange", {
        item: {
          text: this.$t("casinoBetting.date.last24Hours"),
          value: "last24Hours",
        },
        option: 0,
      });
      this.$store.commit("setCasinoCustomRange", {
        from: "",
        to: "",
      });
      // Reset Form

      this.$store.commit("setPaymentMonth", {
        value: (() => {
          let d = new Date(new Date().setMonth(new Date().getMonth() - 1));
          return new Date(d - d.getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 7);
        })(),
      });

      this.$store.commit("disablePaymentMonth");

      this.$nextTick(() => {
        this.$refs.form.inputs.forEach((input) => {
          if (!input.disabled) {
            input.reset();
          }
        });

        this.$store.commit("enablePaymentMonth");
      });
    },

    /// Logic Enable Filters:
    enableFilters(route) {
      // Setup Filter:
      // 'Setters' from Vuex:
      const filters = [
        "FiltersWrap",
        "RangeGlobal",
        "AutocompleteNamePlayers",
        "SelectResultBet",
        "SelectStatusBetOnline",
        "EventNumber",
        "GroupExport",
        "GamingType",
        "PaymentMonth",
        "CasinoRange",
        "CasinoBetsStatus",
      ];

      // 1. hide all filters
      filters.forEach((filter) => {
        this.$store.commit(filter, false);
      });

      // 2. Enable chosen filters on the route
      if (route.matched.some((record) => record.meta.filters)) {
        this.$store.commit("FiltersWrap", true);
        route.matched.forEach((record) => {
          if (record.meta.filters) {
            record.meta.filters.forEach((filter) => {
              this.$store.commit(filter, true);
            });
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.filters-wraps {
  flex-wrap: wrap;
}
.filters-wraps > div {
  flex-basis: 33.33333%;
}
</style>
